export default __webpack_public_path__ + "static/media/tabel-analisa-vendor.5a047bed.png";